function setHeaderHeight() {
  // Adjust selectors as needed for your theme
  const announcementBar = document.querySelector('#epb_bar');
  const header = document.querySelector('sticky-header');

  const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  const announcementBackground = document.querySelector('#epb_background');
  const headerHeight = header ? header.offsetHeight : 0;

  let headerGrpHeight = announcementHeight + headerHeight;

  document.querySelectorAll('.header-element').forEach((element) => {
    headerGrpHeight += element.offsetHeight;
  });

  // Set the CSS variable on :root
  document.documentElement.style.setProperty('--header-height', `${headerGrpHeight}px`);
  document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
  
  if (announcementBackground) {
    announcementBackground.style.zIndex = 3;
  }

  let footerHeight = 0;
  if (window.innerWidth >= 1200) {
    const consentBanner = document.querySelector('.cc-banner');
    if (consentBanner) {
      footerHeight = consentBanner.offsetHeight;
    }
  }
  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
}

const observer = new MutationObserver(() => {
  setHeaderHeight();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

const announcementBar = document.querySelector('#epb_bar');
if (announcementBar) {
  // Also observe attribute/size changes on the bar itself
  observer.observe(announcementBar, {
    attributes: true,
    childList: true,
    subtree: true,
  });
}
window.addEventListener('resize', setHeaderHeight);

document.addEventListener('consentmoSignal_onLoad', function(eventData) {
  setTimeout(setHeaderHeight, 100);
});
document.addEventListener('consentmoSignal', function(event) {
  setTimeout(setHeaderHeight, 25);
});
